import * as vg from "vgapp";
window.vg = vg;

require('./vegas')

import './01-plugins/listener';
import './02-modules/modules';
import './03-services/listeners';
